<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="industryEdit" :model="formData" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="父级产业" prop="SysIndustry.parentIndustryId">
            <el-cascader class="input-item" v-model="industryEdit.parentIndustryId.value" :options="industryEdit.parentIndustryId.impl.dropdownList" filterable
              :clearable="true" :show-all-levels="false" placeholder="父级产业"
              :props="{value: 'id', label: 'name', checkStrictly: true}"
              @visible-change="industryEdit.parentIndustryId.impl.onVisibleChange"
              @change="onParentIndustryIdValueChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="行业名称" prop="SysIndustry.industryName">
            <el-input class="input-item" v-model="formData.SysIndustry.industryName"
              :clearable="true" placeholder="行业名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="显示顺序" prop="SysIndustry.showOrder">
            <el-input class="input-item" v-model="formData.SysIndustry.showOrder"
              :clearable="true" placeholder="显示顺序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('industryEdit:industryEdit:add')"
              @click="onAddClick()">
              保存
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize" :plain="true"
              @click="onCancel(false)">
              关闭
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SysIndustryController, DictionaryController } from '@/api';

export default {
  name: 'industryEdit',
  props: {
    // 是否支持级联操作
    supportCascadeAdd: {
      type: String,
      default: '0'
    },
    // 级联操作数据
    rowData: {
      type: Object
    },
    industryId: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        SysIndustry: {
          industryId: undefined,
          parentIndustryId: undefined,
          industryName: undefined,
          showOrder: undefined,
          deletedFlag: undefined,
          isDatasourceInit: false
        }
      },
      industryEdit: {
        formFilter: {
        },
        formFilterCopy: {
        },
        parentIndustryId: {
          impl: new DropdownWidget(this.loadParentIndustryIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        menuBlock: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess, data) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess, data);
      }
    },
    /**
     * 父级产业下拉数据获取函数
     */
    loadParentIndustryIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIndustryDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 父级产业选中值改变
     */
    onParentIndustryIdValueChange (value) {
      this.formData.SysIndustry.parentIndustryId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
     * 更新产业编辑
     */
    refreshIndustryEdit (reloadData = false) {
      this.loadSysIndustryData().then(res => {
        if (!this.industryEdit.isInit) {
          // 初始化下拉数据
          this.industryEdit.parentIndustryId.impl.onVisibleChange(true).then(res => {
            this.industryEdit.parentIndustryId.value = findTreeNodePath(res, this.formData.SysIndustry.parentIndustryId, 'id');
          }).catch(e => {});
        }
        this.industryEdit.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onAddClick () {
      this.$refs.industryEdit.validate((valid) => {
        if (!valid) return;
        // 如果是级联表格的添加或者编辑弹窗
        if (this.supportCascadeAdd === '1') {
          let formData = {
            parentIndustryIdDictMap: findTreeNode(this.industryEdit.parentIndustryId.impl.dropdownList, this.formData.SysIndustry.parentIndustryId, 'id'),
            ...this.formData.SysIndustry
          };
          this.onCancel(true, formData);
          return;
        }

        let params = {
          sysIndustryDto: {
            industryId: this.industryId,
            parentIndustryId: this.formData.SysIndustry.parentIndustryId,
            industryName: this.formData.SysIndustry.industryName,
            showOrder: this.formData.SysIndustry.showOrder
          }
        };

        if (this.industryId == null) {
          SysIndustryController.add(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        } else {
          SysIndustryController.update(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        }
      });
    },
    /**
     * 获取产业表详细信息
     */
    loadSysIndustryData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.SysIndustry.isDatasourceInit) {
          if (
            this.industryId == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            industryId: this.industryId
          };
          SysIndustryController.view(this, params).then(res => {
            this.formData.SysIndustry = {...res.data, isDatasourceInit: true};
            if (this.formData.SysIndustry.parentIndustryIdDictMap && this.industryEdit.parentIndustryId.impl.dirty) {
              this.industryEdit.parentIndustryId.impl.dropdownList = [this.formData.SysIndustry.parentIndustryIdDictMap];
            }
            if (this.formData.SysIndustry.parentIndustryId) this.industryEdit.parentIndustryId.value = [this.formData.SysIndustry.parentIndustryId];
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.SysIndustry.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        SysIndustry: {
          industryId: undefined,
          parentIndustryId: undefined,
          industryName: undefined,
          showOrder: undefined,
          deletedFlag: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshIndustryEdit();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    // 初始化级联数据
    if (this.supportCascadeAdd === '1' && this.rowData != null) {
      this.formData.SysIndustry = {
        ...this.rowData
      }
    }
  },
  watch: {
  }
}
</script>
